module.exports = __webpack_public_path__ + "static/fcra-2017-18-q3-a88ab0484aec20d8d40ed768223934d5.pdf";